module.exports = __webpack_public_path__ + "static/media/ic_chat.00c690d2.svg";